import {
  AffectedStaffDailyReport,
  AffectedStaffDailyReportInput
} from '../../../lib/types/models/affectedStaff/affected-staff-daily-report'
import {
  AffectedStaffEndOfStayReport,
  AffectedStaffEndOfStayReportInput
} from '../../../lib/types/models/affectedStaff/affected-staff-end-of-stay-report'

export enum PdfFormat {
  partial = 'PARTIAL',
  complete = 'COMPLETE'
}

export const pdfFormatEnumMapping = {
  [PdfFormat.partial]: 'Partiel',
  [PdfFormat.complete]: 'Complet'
}

export type PdfChoicesInput = {
  format: PdfFormat
}

export type RadioChoiceProps<T> = {
  value?: T
  disabled?: boolean
  onChange: (value: T) => void
}

export const mapAffectedStaffEndOfStayReportToInput = (
  data: AffectedStaffEndOfStayReport
): AffectedStaffEndOfStayReportInput => ({
  activitiesEvenings: data.activitiesEvenings,
  additionalRemarks: data.additionalRemarks,
  classroomEquipment: data.classroomEquipment,
  excursionsFeedback: data.excursionsFeedback,
  foodQuality: data.foodQuality,
  managementTeam: data.managementTeam,
  peersInvolvement: data.peersInvolvement,
  residenceFacilities: data.residenceFacilities,
  residenceImprovements: data.residenceImprovements
})

export const mapAffectedStaffDailyReportToInput = (
  data: AffectedStaffDailyReport
): AffectedStaffDailyReportInput => ({
  date: data.date,
  accidentIssue: data.accidentIssue,
  conductIssue: data.conductIssue,
  damageIssue: data.damageIssue,
  disciplineIssue: data.disciplineIssue,
  drugsIssue: data.drugsIssue,
  moralHarassmentIssue: data.moralHarassmentIssue,
  sexualHarassmentIssue: data.sexualHarassmentIssue,
  healthIssue: data.healthIssue,
  otherIssue: data.otherIssue,
  teamIssue: data.teamIssue,
  theftIssue: data.theftIssue,
  violenceIssue: data.violenceIssue,

  previousIssuesProgress: data.previousIssuesProgress,
  incidentDetails: data.incidentDetails
})

export const affectedStaffDailyReportInitialValues: AffectedStaffDailyReportInput = {
  accidentIssue: false,
  conductIssue: false,
  damageIssue: false,
  disciplineIssue: false,
  drugsIssue: false,
  moralHarassmentIssue: false,
  sexualHarassmentIssue: false,
  healthIssue: false,
  otherIssue: false,
  teamIssue: false,
  theftIssue: false,
  violenceIssue: false
}
